import { Route, Routes } from 'react-router-dom';
import AdminList from './components/AdminList';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function AdminRoutes() {
    return <Routes>{hasAccessRight(AdminAclEnum.ADMIN) && <Route index element={<AdminList />} />}</Routes>;
}
